/**
 *
 *
 *
 *
 *
 */
const getAriaLabelsFromNode = (node: Node): string[] => {
  /*                                                                                      */
  if (node instanceof Element && ["style", "script"].includes(node.tagName.toLowerCase()))
    return [];

  /*                                                             */
  if (node instanceof Text) {
    const trimmedText = node.textContent?.trim() ?? "";
    return trimmedText ? [trimmedText] : [];
  }

  /*                                                                     */
  if (!(node instanceof Element)) return [];

  /*                                                                  */
  if (node.ariaHidden === "true") return [];

  /*                                                           */
  if (node instanceof HTMLElement && getComputedStyle(node).display === "none") return [];

  /*                                                                                   */
  if (node.classList.contains("oc-secondary-action")) return [];

  /*                                                          */
  if (node.ariaLabel) return [node.ariaLabel];

  /*                                                                               */
  if (node instanceof HTMLElement && node.hasAttribute("aria-labelledby")) {
    return node
      .getAttribute("aria-labelledby")!
      .split(" ")
      .map((id) => document.getElementById(id.trim()))
      .filter((el): el is HTMLElement => el instanceof HTMLElement)
      .flatMap(getAriaLabelsFromNode);
  }

  /*                                                                     */
  if (node instanceof HTMLImageElement) {
    const altText = node.alt?.trim();
    return altText ? [altText] : [];
  }

  /*                                                                       */
  if (node instanceof HTMLSlotElement) {
    const assignedNodes = node.assignedNodes();
    if (assignedNodes.length > 0) return assignedNodes.flatMap(getAriaLabelsFromNode);
  }

  /*                                                                         */
  return [...(node.shadowRoot ?? node).childNodes].flatMap(getAriaLabelsFromNode);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const getAriaLabelFromElements = (...nodes: Node[]): string | null => {
  const labelText = nodes.flatMap(getAriaLabelsFromNode).filter(Boolean).join(" ").trim();

  return labelText || null;
};
